<template>
  <basic-card>
    <template slot="header">
     {{$t('accountBalancesItems.accountBalancesItems')}}
    </template>
    <simple-list :columns="listColumns" object-name="accountBalanceItem" query-store-name="account">
    </simple-list>
  </basic-card>
</template>

<script>
import BasicCard from "../components/layout/BasicCard";
import SimpleList from "../components/lists/SimpleList";
import {mapGetters} from "vuex";

export default {
  name: "AccountBalanceItemsView",
  components: {SimpleList, BasicCard},
  computed: {
    ...mapGetters({
      "account": "banking/account"
    })
  },
  data() {
    return {
      listColumns: [
        {
          caption: "Id",
          datum: d => d.id
        },
        {
          caption: this.$t('accounts.account'),
          datum: d => this.account(d.account)?.name ?? "N/A",
          sortField: "account",
          allowSort: true
        },
        {
          caption: this.$t('date'),
          datum: d => this.$formats.formatDate(d.balanceDate, false)
        },
        {
          caption: this.$t('accounts.internal'),
          datum: d => d.internalTransfer ? this.$t("yes") : this.$t("no"),
          sortField: "internalTransfer",
          allowSort: true
        },
        {
          caption: this.$t('accountBalancesItems.amount'),
          datum: d => this.$formats.formatAmount(d.amount / 100),
          exportDatum: d => d.amount / 100,
          sortField: "amount",
          allowSort: true
        },
        {
          caption: this.$t('accounts.currency'),
          datum: d => d.currency,
          sortField: "currency",
          allowSort: true
        },
        {
          caption: this.$t('accountBalancesItems.variableSymbol'),
          datum: d => d.variableSymbol,
          sortField: "variableSymbol",
          allowSort: true
        },
        {
          caption: this.$t('accountBalancesItems.specificSymbol'),
          datum: d => d.specificSymbol,
          sortField: "specificSymbol",
          allowSort: true
        },
        {
          caption: this.$t('accountBalancesItems.counterAccount'),
          datum: d => d.counterAccount + "/" + d.counterAccountBankCode,
          sortField: "counterAccount",
          allowSort: true
        },
        {
          caption:this.$t('accountBalancesItems.counterAccountName'),
          datum: d => d.counterAccountName,
          sortField: "counterAccountName",
          allowSort: true
        },
        {
          caption:this.$t('accountBalancesItems.message'),
          datum: d => d.message,
          sortField: "message",
          allowSort: true
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>